import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiPopover from '@material-ui/core/Popover';
import { combineClasses, styled, useRcPortalWindowContext, useThemeProps, } from '../../foundation';
import { PopoverStyle } from './styles';
import { RcPopoverClasses } from './utils';
var _RcPopover = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcPopover' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcPopoverClasses, classesProp); }, [classesProp]);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    return (React.createElement(MuiPopover, __assign({ container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body }, rest, { ref: ref, classes: classes }), children));
});
var RcPopover = styled(_RcPopover)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), PopoverStyle);
RcPopover.defaultProps = {
    anchorOrigin: { vertical: 'top', horizontal: 'left' },
    anchorReference: 'anchorEl',
};
RcPopover.displayName = 'RcPopover';
export { RcPopover };
var templateObject_1;
